import styled from 'styled-components';

const CardMeta = styled.div`
    padding: 1rem;
`;

export default CardMeta;
